import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-banner-skeleton',
  templateUrl: './banner-skeleton.component.html',
  styleUrls: ['./banner-skeleton.component.scss'],
})
export class BannerSkeletonComponent implements OnInit {

  constructor(
    public platform :Platform
  ) { }

  ngOnInit() {}

}
